import { constantRoutes } from '@/router'
import { getRouterList } from '@/api/router'
import { convertRouter } from '@/utils/handleRoutes'

const state = () => ({
  // 路由列表
  routes: [],
  // 是否以全屏幕模式打开（即：不显示头部、底部、侧边栏等区域）
  fullScreenState: false,
  sourceSystem: '',
  rolePermission: '',
  menus: [],
})
const getters = {
  routes: (state) => state.routes,
  fullScreenState: (state) => state.fullScreenState,
  sourceSystem: (state) => state.sourceSystem,
  rolePermission: (state) => state.rolePermission,
}
const mutations = {
  setAllRoutes(state, routes) {
    state.routes = constantRoutes.concat(routes)
  },
  setFullScreenState(state, fullScreenState) {
    state.fullScreenState = fullScreenState
  },
  setSourceSystem(state, sourceSystem) {
    state.sourceSystem = sourceSystem
  },
  setRolePermission(state, rolePermission) {
    state.rolePermission = rolePermission
  },
  cleanRoutes(state) {
    state.routes = []
  },
  setAllMenus(state, menus) {
    state.menus = menus
  },
}
const actions = {
  async setAllRoutes({ commit }) {
    let { value } = await getRouterList()
    // 通配符路由必须添加在最后
    //value.push({ path: '*', redirect: '/404', hidden: true })
    let accessRoutes = convertRouter(value)
    accessRoutes.push({
      path: '*',
      redirect: '/404',
      hidden: true,
    })
    commit('setAllMenus', value)
    commit('setAllRoutes', accessRoutes)
    return accessRoutes
  },
  setFullScreenState({ commit }, fullScreenState) {
    commit('setFullScreenState', fullScreenState)
    return fullScreenState
  },
  setSourceSystem({ commit }, sourceSystem) {
    commit('setSourceSystem', sourceSystem)
    return sourceSystem
  },
  setRolePermission({ commit }, rolePermission) {
    commit('setRolePermission', rolePermission)
    return rolePermission
  },
  cleanRoutes({ commit }) {
    commit('cleanRoutes')
  },
}
export default { state, getters, mutations, actions }
